import MessageBox from './components/message-box'
import Toast from './components/toast'
import ActionSheet from './components/action-sheet'


//plugins
import $messageBox from './plugins/message-box';
import $Toast from './plugins/toast';

const PLUGINS = {
  $messageBox,$Toast
}


const COMPONENTS = {
  MessageBox,Toast,ActionSheet
}

const NIOUI = {
  ...COMPONENTS
};


const install = function (Vue, opts = {}) {
  if (install.installed) return;

  Object.keys(COMPONENTS).forEach(key => {
    Vue.component(key, COMPONENTS[key]);
  });

  Object.keys(PLUGINS).forEach(key => {
    Vue.prototype[key] = PLUGINS[key];
  });

}

NIOUI.install = install;
export default NIOUI;




// WEBPACK FOOTER //
// ./src/index.js